module.exports = __webpack_public_path__ + "img/Logo TR Toolbox.79e46938.png";